

export function generateParoslyAlert(providerId, threshold, st_source, metric, severity, name, AlertType) {

    const metricMapping = {
        "Completeness": "completeness",
        "Validity": "validity",
    };
    const providerMapping = {
        "SCAE": "SCAE",
        "SIEMENS": "Siemens",
        "SWARCO": "Swarco",
    };

    const stParameters = `[ { \"name\": \"provider_id\", \"value\": \"${providerId}\" }, { \"name\": \"threshold\", \"value\": \"${threshold}\" } ]`;    
    const id = Math.random().toString(36).substring(2, 7);
    return {
      data: {
        groups: [
          {
            name: "Completeness alerts_" + id,
            rules: [
              {
                alert: name,
                expr: `provider_${metricMapping[metric]}_avg{provider_id=~".*${providerId}"} < ${threshold}`,
                labels: {
                  severity: severity
                },
                annotations: {
                  summary: name,
                  description: `The data ${metricMapping[metric]} for ${AlertType} {{ $labels.provider_id }} is {{ $value }}%.`,
                  st_source: st_source,
                  st_parameters: stParameters
                }
              }
            ]
          }
        ]
      }
    };
  }
  